import React, { useState } from 'react';
import { updateUserType } from 'services/userTypeService';
import { USER_TYPE_OPTIONS, formatUserTypeLabel } from 'utils/jwt';
import './UserTypeModal.css';

const USER_TYPE_DESCRIPTIONS = {
  agence: 'Vous gérez un(e) ou plusieurs modèles.',
  model: 'Vous êtes créateur/créatrice de contenu.',
  chatter: 'Vous répondez aux fans pour le compte de créateurs/créatrices.',
};

const UserTypeModal = ({ open }) => {
  const [error, setError] = useState('');
  const [loadingType, setLoadingType] = useState(null);

  if (!open) {
    return null;
  }

  const handleSelect = async (userType) => {
    if (loadingType) {
      return;
    }

    setError('');
    setLoadingType(userType);

    try {
      await updateUserType(userType);
      window.location.reload();
    } catch (err) {
      setError(err.message || 'Une erreur est survenue.');
      setLoadingType(null);
    }
  };

  return (
    <div className="user-type-modal-overlay">
      <div className="user-type-modal-card">
        <h2>Quel est votre profil ?</h2>
        <p className="user-type-modal-description">
          Sélectionnez le type de compte qui correspond le mieux à votre activité pour
          personnaliser davantage votre expérience.
        </p>

        {error && <div className="user-type-modal-error">{error}</div>}

        <div className="user-type-modal-options">
          {USER_TYPE_OPTIONS.map((type) => (
            <button
              key={type}
              type="button"
              className="user-type-modal-button"
              disabled={!!loadingType}
              onClick={() => handleSelect(type)}
            >
              <span className="user-type-modal-button-label">{formatUserTypeLabel(type)}</span>
              <span className="user-type-modal-button-description">
                {USER_TYPE_DESCRIPTIONS[type]}
              </span>
              {loadingType === type && <span className="user-type-modal-loader">Mise à jour...</span>}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserTypeModal;
